<template>
  <!-- 活动信息买赠 -->
  <div class="con">
    <van-action-sheet v-model="show" title="优惠促销" @close="close">
      <div class="content border_top1px">
        <div
          class="font12 font_weight400 colo087 text_left line_height_17 free_pad"
        >
          <img
            src="@/assets/product/icon_free@2x.png"
            alt=""
            class="icon_free"
          />
          <div v-if="mallretailspu.gift">
            {{ mallretailspu.gift.activityName }}
          </div>
        </div>
        <div
          v-for="(item, index) in mallretailspu.gift.spus"
          :key="index"
          class="content border_top1px clearfix"
        >
          <div class="left product_img">
            <img :src="item.spuImg" alt="" class="img_img" />
            <img
              src="@/assets/product/icon_right_free@2x.png"
              alt=""
              class="img_icon"
            />
          </div>
          <div class="name font0 left text_left font_weight400">
            <div class="font12 colo0 name_name">
              {{ item.name }}
            </div>
            <div
              v-if="item.stock === 0 || item.stock === null"
              class="font10 colof00 name_det"
            >
              已赠完
            </div>
            <div
              class="name_spec clearfix"
              @click="goGiftSelect(index, item.id)"
              v-if="
                (checkGiftList && checkGiftList.length) ||
                  Object.values(item.skus)[0]
              "
            >
              <div
                class="left spec_bg spec_det font10 text_left font_weight400 colo055 line_height_16 font_line_1"
              >
                规格：{{
                  checkGiftList.length
                    ? checkGiftList[0].spec
                    : Object.values(item.skus)[0]
                    ? Object.values(item.skus)[0].name
                    : ""
                }}
              </div>
              <img
                src="@/assets/common/icon_cell_more_24@2x.png"
                alt=""
                class="left more_icon"
              />
            </div>
          </div>
          <div
            class="right free_btn font10 font_weight500 colof"
            @click="goDetail(item.id)"
          >
            查看赠品
          </div>
        </div>
        <div
          class="font14 font_weight500 colof line_height_40 btn"
          @click="close"
        >
          确认
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
export default {
  props: {
    checkGiftList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      show: true
    };
  },
  watch: {
    checkGiftList: {
      handler(newVAlue, oldVal) {
        console.log(newVAlue, oldVal);
        this.name = newVAlue[0].spec;
      }
    }
  },
  computed: {
    mallretailspu() {
      return this.$store.getters.mallretailspu;
    }
  },
  methods: {
    close() {
      this.show = true;
      this.$emit("closeSheet");
    },
    goGiftSelect(index, id) {
      // console.log(index, "ddsdsd");
      this.$emit("goGiftSelect", index, id);
    },
    goDetail(id) {
      this.$emit("goDetail", id);
      this.$emit("closeSheet");
    }
  }
};
</script>

<style lang="less" scoped>
.con {
  background: #fff;
  .content {
    margin: 2px 12px 0;
    padding: 13px 0;
    .btn {
      background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
      border-radius: 20px;
      margin-top: 135px;
    }
    .free_pad {
      padding-bottom: 12px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .icon_free {
      width: 32px;
      margin-right: 8px;
    }
    .product_img {
      width: 69px;
      position: relative;
      .img_img {
        width: 100%;
      }
      .img_icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 31px;
      }
    }
    .name {
      padding: 4px 0 0 8px;
      .name_name {
        width: 160px;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .name_det {
        padding-top: 13px;
      }
    }
    .free_btn {
      margin-top: 35px;
      line-height: 24px;
      padding: 0 12px;
      background: #e02020;
      border-radius: 12px;
    }
  }
  .name_spec {
    margin-top: 11px;
    background: rgba(0, 0, 0, 0.03);
    display: inline-block;
    .spec_det {
      max-width: 90px;
      overflow-y: hidden;
    }
    .spec_bg {
      border-radius: 2px;
    }
    .more_icon {
      width: 16px;
    }
    .delete_icon {
      width: 16px;
    }
  }
}
</style>
